import { NgModule }               from '@angular/core';
import { FormsModule }            from '@angular/forms';
import { CommonModule }           from '@angular/common';
import { AppRoutingModule }       from '../app-routing.module';
import { NoticeComponent }        from './notice.component';
import { NgxMyDatePickerModule }  from 'ngx-mydatepicker';
import { CommonToolModule }       from '../common/common-tool.module';
import { NoticeShowComponent }    from './notice-show.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    NgxMyDatePickerModule,
    CommonToolModule    //共通部品をcomponentとしてimportするとエラーになる、module化してimportする
  ],
  exports: [
    NoticeComponent,
    NoticeShowComponent
  ],
  declarations: [
    NoticeComponent,
    NoticeShowComponent
  ],
  providers: [  ]
})
export class NoticeModule {}



// WEBPACK FOOTER //
// ./src/app/notice/notice.module.ts